/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscriptions_himsearch.js                                                        */
/**********************************************************************************************************************/
/* Subscriptions HimSearch */

HafasWebapp.prototype.subscriptions.HimSearch = function (_me) {

  Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.HimSearch.resize, _me));
  Hafas.ps.sub('/GUI/leaveContext/HimSearch', Hafas.bind(_me.Controller.HimSearch.leaveContext, _me));
  Hafas.ps.sub('/GUI/closeView/HimSearch', Hafas.bind(_me.Controller.HimSearch.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/HimSearch', Hafas.bind(_me.Controller.HimSearch.restoreView, _me));

  Hafas.ps.sub('/HimSearch/postForm', Hafas.bind(_me.Controller.HimSearch.postForm, _me));
  Hafas.ps.sub("/HimSearch/toggleDetails", Hafas.bind(_me.Controller.HimSearch.toggleDetails, _me));

  Hafas.ps.sub('/HimSearch/hideSortOrder', Hafas.bind(_me.Controller.HimSearch.hideSortOrder, _me));

  Hafas.ps.sub('/dateTimePicker/selectDateTime/HimSearch_dateB', Hafas.bind(_me.Controller.HimSearch.setBeginDate, _me));
  Hafas.ps.sub('/dateTimePicker/selectDateTime/HimSearch_dateE', Hafas.bind(_me.Controller.HimSearch.setEndDate, _me));

  Hafas.ps.sub('/options/gui/toggle/group', Hafas.bind(_me.Controller.HimSearch.resizeForm, _me));
  Hafas.ps.sub('/options/gui/toggle/group', Hafas.bind(_me.Controller.HimSearch.hideSortOrder, _me));

  Hafas.ps.sub('/HimSearch/setTextFilter', Hafas.bind(_me.Controller.HimSearch.setTextFilter, _me));
  // Linien / Product filter for him search
  Hafas.ps.sub('/HimSearch/setProductFilter', Hafas.bind(_me.Controller.HimSearch.setProductFilter,_me));

  Hafas.ps.sub('/himsearch/selectProduct', Hafas.bind(_me.Controller.HimSearch.selectProduct, _me));

  Hafas.ps.sub('/HimSearch/sortOrder/setSortMode', Hafas.bind(_me.Controller.HimSearch.setSortMode, _me));

  Hafas.ps.sub('/HimSearch/clickOnCluster', Hafas.bind(_me.Controller.HimSearch.handleClusterClick, _me));

  Hafas.ps.sub('/options/set/value', Hafas.bind(_me.Controller.HimSearch.checkActiveCategories, _me));
  Hafas.ps.sub('/HimSearch/renderCategoryDescription', Hafas.bind(_me.Controller.HimSearch.renderCategoryDescriptions, _me));

  Hafas.ps.sub("/himsearch/clearInput", Hafas.bind(_me.Controller.HimSearch.clearInput, _me));

  Hafas.ps.sub('/HimSearch/options/activateLocalStorage', Hafas.bind(_me.Controller.HimSearch.setOptionStorageActive,_me));
};
